/**
 * Scroll reveals for Webflow-exported sections.
 * No markup changes: targets are picked by class. Elements already in view at
 * load are left alone (no flash). Styles live in
 * src/styles/includes/_motion-client-overrides.scss.
 */
var Motion = function() {

	this.options = {
		// Elements that fade up as they enter the viewport
		targets: [
			'.section-header_component',
			'.card-grid_item',
			'.highlight-card_item',
			'.home-leasing_step',
			// Site-wide (2 Oct): same fade-up for the other section blocks.
			// Tilted frames are skipped so their rotation does not jump. Split sections
			// animate their text content only, not the photo. The Quiet streets tab
			// block is left still.
			'.home-mosaic_item',
			'.gallery_item',
			'.split-frame_content',
			'.split-bleed_content',
			'.features-list_col',
			'.features-list_media:not(.is-tilted)',
			'.history_component',
			'.cta-band_component',
			'.footer_cta-wrap',
			'.home-leasing_faq-item',
			// Intro blocks (2 Oct)
			'.home-intro_component',
			'.intro-body-center_content',
			'.homes-index_header',
			'.floorplan-header_intro',
			'.form-split_intro',
			// More cards (2 Oct)
			'.home-features_card',
			'.floorplan-listing_card'
		].join(','),
		// Never touch the heroes or anything inside a modal or banner
		exclude: '.section_page-hero, .section_home-hero, .mol-Modal, .layout-BannersContainer, .navbar1_master',
		staggerMs: 80,
		maxStaggerMs: 320
	};

};

Motion.prototype.init = function() {

	var self = this;

	if (!('IntersectionObserver' in window)) {
		return;
	}
	if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return;
	}

	var viewportBottom = window.innerHeight * 0.9;
	var items = [];

	document.querySelectorAll(this.options.targets).forEach(function(el) {
		if (el.closest(self.options.exclude)) {
			return;
		}
		// Already on screen at load: leave it visible
		if (el.getBoundingClientRect().top < viewportBottom) {
			return;
		}
		items.push(el);
	});

	if (!items.length) {
		return;
	}

	// A block inside another animated block rides with its parent
	items = items.filter(function(el) {
		return !items.some(function(other) {
			return other !== el && other.contains(el);
		});
	});

	if (!items.length) {
		return;
	}

	// Stagger siblings that share a parent (card grids)
	var counts = new Map();
	items.forEach(function(el) {
		var n = counts.get(el.parentElement) || 0;
		counts.set(el.parentElement, n + 1);
		el.style.setProperty('--reveal-delay', Math.min(n * self.options.staggerMs, self.options.maxStaggerMs) + 'ms');
		el.setAttribute('data-reveal', '');
	});

	document.documentElement.classList.add('motion');

	function reveal(el) {
		el.classList.add('is-revealed');
		// Hand the element back to its normal hover styles once the fade is done
		setTimeout(function() {
			el.removeAttribute('data-reveal');
			el.classList.remove('is-revealed');
			el.style.removeProperty('--reveal-delay');
		}, 1200);
	}

	var observer = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				observer.unobserve(entry.target);
				reveal(entry.target);
			}
		});
	}, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

	items.forEach(function(el) {
		observer.observe(el);
	});

};

export default Motion;
